<template>
  <div class="custom">
    <template v-if="customData.businessID === CHAT_MSG_CUSTOM_TYPE.SERVICE">
      <div>
        <h1>
          <label>{{ extension.title }}</label>
          <a
            v-if="extension.hyperlinks_text"
            :href="extension.hyperlinks_text.value"
            target="view_window"
            >{{ extension.hyperlinks_text.key }}</a
          >
        </h1>
        <ul v-if="extension.item && extension.item.length > 0">
          <li v-for="(item, index) in extension.item" :key="index">
            <a
              v-if="isUrl(item.value)"
              :href="item.value"
              target="view_window"
              >{{ item.key }}</a
            >
            <p v-else>
              {{ item.key }}
            </p>
          </li>
        </ul>
        <article>{{ extension.description }}</article>
      </div>
    </template>
    <template
      v-else-if="customData.businessID === CHAT_MSG_CUSTOM_TYPE.EVALUATE"
    >
      <div class="evaluate">
        <h1>{{ TUITranslateService.t("message.custom.对本次服务评价") }}</h1>
        <ul class="evaluate-list">
          <li
            v-for="(item, index) in Math.max(customData.score, 0)"
            :key="index"
            class="evaluate-list-item"
          >
            <Icon :file="star" class="file-icon" />
          </li>
        </ul>
        <article>{{ customData.comment }}</article>
      </div>
    </template>
    <template v-else-if="customData.businessID === CHAT_MSG_CUSTOM_TYPE.ORDER">
      <div class="order" @click="openLink(customData.link)">
        <img :src="customData.imageUrl" />
        <main>
          <h1>{{ customData.title }}</h1>
          <p>{{ customData.description }}</p>
          <span>{{ customData.price }}</span>
        </main>
      </div>
    </template>
    <template v-else-if="customData.businessID === CHAT_MSG_CUSTOM_TYPE.LINK">
      <div class="textLink">
        <p>{{ customData.text }}</p>
        <a :href="customData.link" target="view_window">{{
          TUITranslateService.t("message.custom.查看详情>>")
        }}</a>
      </div>
    </template>
    <template
      v-else-if="
        customData.businessID === 'job_info_yaoqing' &&
        customData.extension == 2
      "
    >
      <!-- down_type;//简历类型 1:在线简历2:附件简历 -->
      <div>
        <div>向您投递{{customData.down_type == 2 ? '附件简历' : ''}}
          <span class="c" @click="closeoutDialogShow">{{ customData.resume_name }}<i class="el-icon-arrow-right"></i>
          </span>
        </div>
        <div style="display:flex;justify-content: space-between;border-top:1px solid #dcdfe6;margin-top: 6px;">
          <div style="font-weight: 200;">{{customData.job_name}}</div>
          <div style="color:red;">
            <span>{{customData.job_salary}}</span>
            <span v-if="customData && customData.settlement_type">
              {{ customData && customData.settlement_type?'('+ customData.settlement_type +')':'' }}
            </span>
          </div>
        </div>
        <div style="font-weight: 200;">{{customData.job_info}}</div>
        <!-- <p>
          向您发送简历
          <span class="c" @click="closeoutDialogShow">查看 ></span>
        </p> -->
      </div>
    </template>
    <template
      v-else-if="
        customData.businessID === 'job_info_yaoqing' &&
        customData.extension == 1
      "
    >
      <div class="textLink">
        <div class="sdfsd">邀请投递</div>
        <div class="job">
          <div class="jobNames">{{ customData?.jobName }}</div>
          <div class="salarys">
            <span>{{ customData?.salary }}</span>
            <span v-if="customData && customData.settlement_type">
              {{ customData && customData.settlement_type?'('+ customData.settlement_type +')':'' }}
            </span>
          </div>
        </div>
        <div class="jobInfos">{{ customData?.jobInfo }}</div>
      </div>
    </template>
    <template
      v-else-if="
        customData.businessID === 'job_info_yaoqing' &&
        customData.extension == 3
      "
    >
      <div class="textLink">
        <div class="sdfsd" style="font-size: 15px;">已发送面试邀请
          <span style="color:#2878ff;cursor: pointer;" @click="viewSteps">查看<i class="el-icon-arrow-right"></i>
          </span>
        </div>
      </div>
    </template>
    <template v-else>
      <span v-html="content.custom" />
    </template>
    <!-- <Dialog
      title="查看简历"
      :show.sync="outDialogShow"
      :isH5="!isPC"
      :isHeaderShow="isPC"
      @submit="handleManage"
    >
      <div class="bs">
        <div class="textLink">
          <div class="fsa">
            <div class="icon-unselected"></div>
          </div>
          <div class="rre">
            <div class="jobs">
              <div class="jobNames">123</div>
              <div class="salarys">123</div>
            </div>
            <div class="jobInfos">123</div>
          </div>
        </div>
      </div>
    </Dialog> -->
    <sendSteps ref="sendStepsRef"  />
    <PdfPreview ref="pdfPreviewRef" />
  </div>
</template>

<script lang="ts" setup>
import { watchEffect, ref, nextTick } from "../../../../adapter-vue";
import {
  TUITranslateService,
  IMessageModel,
} from "@tencentcloud/chat-uikit-engine";
import { isUrl, JSONToObject } from "../../../../utils/index";
import { CHAT_MSG_CUSTOM_TYPE } from "../../../../constant";
import { ICustomMessagePayload } from "../../../../interface";
import { isPC } from "../../../../utils/env";
import Dialog from "../../../common/Dialog/index.vue";
import Icon from "../../../common/Icon.vue";
import star from "../../../../assets/icon/star-light.png";
import sendSteps from "@/components/xypComponents/sendSteps.vue";
import PdfPreview from "@/components/PdfPreview.vue";
const emits = defineEmits(["MessageCustomshow"]);
interface Props {
  messageItem: IMessageModel;
  content: any;
}

const props = withDefaults(defineProps<Props>(), {
  messageItem: undefined,
  content: undefined,
});

const custom = ref();
const message = ref<IMessageModel>();
const extension = ref();
const sendStepsRef = ref();
const pdfPreviewRef = ref();
const customData = ref<ICustomMessagePayload>({
  businessID: "",
  extension: "",
});

watchEffect(() => {
  custom.value = props.content;
  message.value = props.messageItem;
  const { payload } = props.messageItem;
  customData.value = payload.data || "";
  customData.value = JSONToObject(payload.data);
  if (payload.data === CHAT_MSG_CUSTOM_TYPE.SERVICE) {
    extension.value = JSONToObject(payload.extension);
  }
});
const openLink = (url: any) => {
  window.open(url);
};
function closeoutDialogShow() {
  // 如果是附件简历（down_type == 2），使用 PdfPreview 预览
  if (customData.value.down_type == 2) {
    pdfPreviewRef.value?.open({
      url: customData.value.attach_path,
      name: customData.value.resume_name
    });
  } else {
    // 在线简历，走原有逻辑
    let { conversationID = "" } = message.value;
    emits("MessageCustomshow", conversationID);
  }
}
const handleManage = () => {
  outDialogShow.value = false;
};
const viewSteps = () =>{
  sendStepsRef.value?.toggle(true);
  sendStepsRef.value?.getdetails({...customData.value});
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/styles/common";

a {
  color: #679ce1;
}

.custom {
  font-size: 14px;

  h1 {
    font-size: 14px;
    color: #000;
  }

  h1,
  a,
  p {
    font-size: 14px;
  }

  .evaluate {
    ul {
      display: flex;
      padding: 10px 0;
    }

    &-list {
      display: flex;
      flex-direction: row;

      &-item {
        padding: 0 2px;
      }
    }
  }

  .order {
    display: flex;

    main {
      padding-left: 5px;

      p {
        font-family: PingFangSC-Regular;
        width: 145px;
        line-height: 17px;
        font-size: 14px;
        color: #999;
        letter-spacing: 0;
        margin-bottom: 6px;
        word-break: break-word;
      }

      span {
        font-family: PingFangSC-Regular;
        line-height: 25px;
        color: #ff7201;
      }
    }

    img {
      width: 67px;
      height: 67px;
    }
  }
}
.job {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.jobNames {
  font-size: 16px;
  color: #333333;
}
.salarys {
  font-weight: bold;
  font-size: 18px;
  color: #ff4141;
  margin: 0 0 0 10px;
}
.jobInfos {
  font-size: 16px;
  color: #999999;
  margin: 10px 0 0;
}
.c {
  color: #006eff;
  cursor: pointer;
}
.sdfsd {
  margin: 0 0 10px;
  font-size: 16px;
}
</style>
